import { useEffect, useState } from "react";

const KEY = "sa_saved_matches";
const EVT = "sa-saved-updated";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
function write(v) {
  localStorage.setItem(KEY, JSON.stringify(v));
  window.dispatchEvent(new CustomEvent(EVT));
}

export function useSavedMatches() {
  const [saved, setSaved] = useState(read);
  useEffect(() => {
    const h = () => setSaved(read());
    window.addEventListener(EVT, h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener(EVT, h);
      window.removeEventListener("storage", h);
    };
  }, []);
  const toggle = (slug) => {
    const cur = read();
    const next = cur.includes(slug) ? cur.filter(x => x !== slug) : [...cur, slug];
    write(next);
  };
  const isSaved = (slug) => saved.includes(slug);
  const clear = () => write([]);
  return { saved, toggle, isSaved, clear };
}
